import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Hero from '../../components/Hero';
import CallToAction from '../../components/CallToAction';
import '../About.css';

// Import images
import academyLogo from '../../assets/images/ProgenX Akademi.png';
import hakkindaHeroImage from '../../assets/images/hakkinda.jpg';
import kalkinma from '../../assets/images/kalkinma.png';
import aws from '../../assets/images/aws.png';
import timteb from '../../assets/images/timteb.jpg';
import googleforstartups from '../../assets/images/googleforstartups.png';
import microsoftforstartups from '../../assets/images/microsoftforstartups.png';
import nvidiaInception from '../../assets/images/nvidia-inception-logo.png';
import etkimlogodct from '../../assets/images/etkimlogodct.png';

const AboutEN = () => {
  return (
    <div className="about">
      <Helmet>
        <title>About ProgenX | Education and Information Technology Company 2026</title>
        <meta name="description" content="ProgenX is a technology company established with TÜBİTAK BİGG funding, accelerating digital transformation in education and transforming the learning experience with innovative technologies. Learn about our vision, mission, and services as a company operating in METU Technopark, AWS Activate member, and holder of the Techno-Entrepreneurship Badge." />
        <meta name="keywords" content="about progenx, progenx vision, progenx mission, digital transformation in education, ai education, tübitak bigg, metu technopark, aws activate, techno-entrepreneurship badge, etkim meb" />
        <meta property="og:title" content="About ProgenX | Education and Information Technology" />
        <meta property="og:description" content="Technology company established with TÜBİTAK BİGG funding, accelerating digital transformation in education." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenx.com.tr/en/about" />
        <link rel="canonical" href="https://progenx.com.tr/en/about" />
        <link rel="alternate" hreflang="tr" href="https://progenx.com.tr/hakkinda" />
        <link rel="alternate" hreflang="en" href="https://progenx.com.tr/en/about" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "ProgenX Education and Information Technologies Inc.",
            "url": "https://progenx.com.tr",
            "logo": "https://progenx.com.tr/logo.png",
            "description": "Technology company offering innovative solutions in education technology, developing AI-powered learning platforms",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Üniversiteler Mah. İhsan Doğramacı Bul. No: 31 İç Kapı No: 20",
              "addressLocality": "Çankaya",
              "addressRegion": "Ankara",
              "postalCode": "06800",
              "addressCountry": "TR"
            },
            "foundingDate": "2020",
            "award": "Techno-Entrepreneurship Badge",
            "memberOf": ["AWS Activate", "ETKİM MEB", "TÜBİTAK BİGG"]
          })}
        </script>
      </Helmet>
      
      <Hero 
        title="About Us" 
        backgroundImage={hakkindaHeroImage}
      />
      
      <section className="about-content">
        <div className="container">
          <div className="about-row">
            <div className="about-text">
              <h2 className="section-title">PROGENX</h2>
              <div className="about-description">
                <p>
                  ProgenX is a technology company that offers innovative solutions in the field of education technology and develops AI-powered learning platforms. 
                  Our company, which has participated in the Turkey Education Technologies Summit (TETZ), operates under ETKİM MEB, is a member of AWS Activate, and 
                  has been awarded the Techno-Entrepreneurship Badge by the Ministry of Industry and Technology of the Republic of Turkey, 
                  aims to be alongside students on their journey to success by supporting digital transformation in education.
                </p>

                <p>
                  As ProgenX, we adopt an approach that accelerates digital transformation across industries and transforms experiences with innovative technologies. With the smart solutions we develop, we recognize each client as unique and offer them completely personalized technology solutions.
                </p>
                <p>
                  ProgenX, a company established with TÜBİTAK BİGG funding, is not limited to education technologies only; it also offers a wide range of services in information technology and digital transformation. With our data science and artificial intelligence solutions, we extract meaningful information from large data sets and add power to businesses' decision-making processes. With our mobile and web application development services, we create user-friendly, high-performance digital products and digitize business processes.
                </p>
                <p>
                  ProgenX is an innovative AI-powered platform that aims to ensure equal opportunities in education and increase students' academic success by offering solutions suitable for each student's individual learning needs. Our goal is to step in where traditional education methods fall short and maximize students' individual potential.
                </p>
                
                <h3>Our Vision</h3>
                <p>
                  We aim to be a leader that maximizes the potential of individuals and businesses by producing innovative solutions worldwide in the fields of education and technology. We aim to implement sustainable digital transformation processes in society by developing technology in a way that everyone can access.
                </p>
                
                <h3>Our Mission</h3>
                <p>
                  As ProgenX, we enable businesses and individuals to discover their unique potential by offering personalized digital solutions. While increasing efficiency with information technology, software, and digital transformation solutions, we set the highest standards in the industry with technology-based innovative projects.
                </p>

                <div className="about-logos-section">
                  <h4 className="about-logos-heading">Backed by</h4>
                  <div className="about-logos-grid about-logos-backed">
                    <div className="about-logo-item">
                      <img src={kalkinma} alt="Turkey Development Fund" />
                    </div>
                  </div>
                  <h4 className="about-logos-heading">Member of</h4>
                  <div className="about-logos-grid about-logos-member">
                    <div className="about-logo-item">
                      <img src={aws} alt="AWS" />
                    </div>
                    <div className="about-logo-item">
                      <img src={timteb} alt="TİMTEB" />
                    </div>
                    <div className="about-logo-item">
                      <img src={googleforstartups} alt="Google for Startups" />
                    </div>
                    <div className="about-logo-item">
                      <img src={microsoftforstartups} alt="Microsoft for Startups" />
                    </div>
                    <div className="about-logo-item">
                      <img src={nvidiaInception} alt="NVIDIA Inception" />
                    </div>
                    <div className="about-logo-item">
                      <img src={etkimlogodct} alt="ETKİM" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="about-image">
              <img src={academyLogo} alt="ProgenX Academy Logo" />
              <div className="about-quote">
                <p>"The best way to predict the future is to create it."</p>
                <p className="quote-author">-Peter Drucker & Abraham Lincoln</p>
              </div>
              <div className="about-cta">
                <Link to="/en/academy" className="btn btn-primary">
                  EXPLORE NOW
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <CallToAction 
        title="Step into the Future with Technology, Meet the Power of Innovation!"
        subtitle="Contact us now and let's make your dreams come true."
        buttonText="Contact Us" 
        buttonLink="/en/contact" 
      />
    </div>
  );
};

export default AboutEN;
